module.exports = __webpack_public_path__ + "img/44.aecda4c6.jpg";